var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",attrs:{"width":_vm.width,"controls":_vm.controls,"preload":_vm.preload,"poster":_vm.videoPoster,"src":_vm.src,"controlsList":"nodownload","disablePictureInPicture":"","playsinline":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }